import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mx-auto flex min-h-[70vh] max-w-content flex-col items-center justify-center px-4 py-20 text-center md:px-6">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-600">
        <i className="ri-emotion-unhappy-line text-3xl" />
      </span>
      <p className="mt-6 font-heading text-5xl font-bold text-foreground-950">404</p>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
        这个页面比主持人还先翻车了
      </h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        你访问的地址不存在，可能链接被改了。别急，前排的位置还在，回首页继续围观本季名场面。
      </p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          返回首页
        </Link>
        <Link
          to="/category/funny"
          className="whitespace-nowrap rounded-md border border-background-300 px-5 py-3 text-sm text-foreground-800 transition-colors hover:bg-background-200"
        >
          去看搞笑名场面
        </Link>
      </div>
    </div>
  );
}